import { CONFIG } from '../core/config';
import { LookupItem } from './static-lookups/lookup-item';
import { DropdownItem } from './dropdown-item';
import { ViewModel } from './view-model';

export class StaticLookup implements ViewModel {
  readonly friendlyTypeNameSingular = 'Lookup';
  readonly apiRoute: string = CONFIG.apiRoutes.lookup;
  identifier: string;
  items: LookupItem[] = [];

  json() {
    return this;
  }

  loadFromJson(data) {
    this.identifier = data.identifier;

    this.items = [];
    if (data.values) {
      for (const key of Object.keys(data.values)) {
        this.items.push(new LookupItem(key, data.values[key]));
      }
    }
  }

  getDropdownItems(): DropdownItem[] {
    const dropdownItems: DropdownItem[] = [];
    this.items.forEach(lookupItem => {
      dropdownItems.push(new DropdownItem(lookupItem.value, lookupItem.key));
    });

    return dropdownItems;
  }
}

